module.exports = __webpack_public_path__ + "./james_f55a2344206e3d44a32ce4560510047f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/james.png
// module id = 469
// module chunks = 0